<script>
import RestPage from '@/common/components/rest/RestPage.vue'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationHistory',

  components: {
    RestPage
  },

  data() {
    return {
      model: null
    }
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    modelId: {
      type: Number,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/${this.modelId}`,
        handler: data => {
          this.model = data
        }
      })
    }
  }
}
</script>

<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <component :is="integration.components.history" :model="model" />
  </rest-page>
</template>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationHistory.vue